import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home, Render } from 'pages';
import { DeviceSizeProvider, StateProvider } from 'providers';
import 'assets/scss/global.scss';

const App = () => (
  <StateProvider>
    <DeviceSizeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/render" element={<Render />} />
        </Routes>
      </BrowserRouter>
    </DeviceSizeProvider>
  </StateProvider>
);

export default App;